/* @jsx h */
import { BottomSheet } from "../BottomSheet";
import { FullScreenSheet, FullScreenSheetSlotProps } from "../FullScreenSheet";
import { defineComponent, h, Teleport, Transition, VNode } from "vue";

// todo: move this into another pkg
export const isPackaged = !!(globalThis as any).ReactNativeWebView;

export type LemmonModalMobileVariant = "bottom-sheet" | "full-screen";

export type LemmonModalProps = {
  onClose: Function;
  renderButtons?: Function;
  title?: string | VNode;
  style?: string;
  overlayBg?: string;
  hideClose?: boolean;
  height?: string;
  disableBottomSheet?: boolean;
  disableCloseByClickingBackdrop?: boolean;
  /** How the modal degrades on mobile. Defaults to "bottom-sheet". */
  mobileVariant?: LemmonModalMobileVariant;
};
export const LemmonModal = defineComponent<LemmonModalProps>({
  name: "LemmonModal",
  props: [
    "onClose",
    "renderButtons",
    "title",
    "style",
    "overlayBg",
    "hideClose",
    "disableBottomSheet",
    "height",
    "disableCloseByClickingBackdrop",
    "mobileVariant",
  ],
  setup(props, { slots }) {
    if (
      !props.disableBottomSheet &&
      window.innerWidth < 600 &&
      props.mobileVariant === "full-screen"
    ) {
      return () => (
        <FullScreenSheet
          isOpen={true}
          onClose={() => props.onClose()}
          style={props.style}
          animation="slide-up"
        >
          {{
            default: ({ close }: FullScreenSheetSlotProps) => (
              <div
                class="flex h-full min-h-0 flex-col bg-base-100"
                style={{ paddingTop: "var(--safe-area-top, 0px)" }}
              >
                {/* Full-screen sheets navigate like a page: back on the left,
                    as in the other full-screen sheets (e.g. POS checkout). */}
                <div class="flex shrink-0 items-center gap-2 border-b px-4 py-3">
                  {!props.hideClose ? (
                    <button
                      class="btn btn-ghost btn-sm btn-circle shrink-0"
                      onClick={() => close()}
                    >
                      <span class="material-symbols-outlined">arrow_back</span>
                    </button>
                  ) : null}
                  <h2 class="min-w-0 flex-1 truncate text-lg font-semibold text-accent">
                    {props.title}
                  </h2>
                </div>
                <div class="flex min-h-0 flex-1 flex-col overflow-y-auto">
                  {slots.default?.()}
                </div>
                {props.renderButtons ? (
                  <div
                    class="shrink-0 bg-base-100"
                    style={{
                      paddingBottom:
                        "var(--safe-area-bottom, env(safe-area-inset-bottom, 0px))",
                    }}
                  >
                    {props.renderButtons()}
                  </div>
                ) : null}
              </div>
            ),
          }}
        </FullScreenSheet>
      );
    }
    if (!props.disableBottomSheet && window.innerWidth < 600) {
      return () => {
        return (
          <BottomSheet
            title={props.title}
            isOpen={true}
            height={props.height}
            hideClose={props.hideClose}
            onClose={() => props.onClose()}
          >
            <div class="flex flex-1 flex-col ">
              <div class="flex flex-1 flex-col ">{slots.default?.()}</div>
              <div class="sticky bottom-0 left-0 right-0 bg-base-100">
                {props.renderButtons ? props.renderButtons() : null}
              </div>
            </div>
          </BottomSheet>
        );
      };
    }
    return () => (
      <Teleport to="body">
        <>
          <div
            onClick={() => {
              if (!props.disableCloseByClickingBackdrop) {
                props.onClose();
              }
            }}
            class="fixed inset-0 bg-accent/10"
            style={{
              background: "oklch(var(--b1)/ 0.6)",
              "will-change": "transform",
              isolation: "isolate",
            }}
          />
          <Transition
            appear
            enter-active-class="transition transform duration-300 ease-out"
            enter-from-class="opacity-0 translate-y-[100px]"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition transform duration-200 ease-in"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-12"
          >
            <div
              style={
                "transform: translateX(-50%);" +
                (props.style ? props.style : "")
              }
              onClick={(e) => e.stopPropagation()}
              class="flex flex-col glossy-bg rounded-lg w-[calc(100vw-24px)] max-w-3xl overflow-hidden fixed  left-1/2 border l-box-shadow sm:w-full max-h-[calc(100vh-20px)] lg:max-h-[calc(100vh-45px)] top-[calc(16px+var(--safe-area-top,0px))] lg:top-[40px]"
            >
              {props.title ? (
                <div class="text-accent flex items-center justify-between p-2 lg:p-4 border-b ">
                  <h2 class="text-2xl text-accent font-normal font-headline">
                    {props.title}
                  </h2>
                  {!props.hideClose ? (
                    <button
                      onClick={() => props.onClose()}
                      class="p-1 text-accent font-bold text-6xl btn btn-sm lg:btn-md"
                    >
                      <span class="flex justify-start items-center">
                        <span class="material-symbols-outlined">close</span>
                      </span>
                    </button>
                  ) : null}
                </div>
              ) : null}
              <div class="overflow-y-auto flex-1 flex flex-col">
                {slots.default?.()}
              </div>
              {props.renderButtons ? <div>{props.renderButtons()}</div> : null}
            </div>
          </Transition>
        </>
      </Teleport>
    );
  },
});
